export function multiSelectDeserialize(selectedItems) {
    const outputJson = {tables: []};
    if (selectedItems.length > 0) {
        selectedItems.forEach(item => {
            const table = {tableName: 'Choose', rows: []};
            const row = {value: item};
            table.rows.push(row);
            outputJson.tables.push(table);
        });
    } else {
        const table = {tableName: 'Choose', rows: []};
        outputJson.tables.push(table);
    }
    return outputJson;
}

export function multiSearchDeserialize(selectedItems) {
    let res = '';
    selectedItems.forEach(item => {
        res += `${item}\r\n`;
    });
    return res;
}
